function Strengths() {
  const strengths = [
    {
      number: "01",
      title: "迅速な対応",
      description: "お問い合わせから提案、開発着手まで素早く対応します。",
    },
    {
      number: "02",
      title: "柔軟な提案",
      description:
        "予算や要件に応じて最適なソリューションをカスタマイズ。無駄のない効率的な開発を実現します。",
    },
    {
      number: "03",
      title: "確かな技術力",
      description:
        "最新の技術スタックに対応し、トレンドを取り入れた高品質なシステムを構築します。",
    },
    {
      number: "04",
      title: "一貫サポート",
      description:
        "企画・設計から開発、運用まで一貫して伴走。長期的なパートナーとして成長を支援します。",
    },
  ];

  return (
    <section
      id="strengths"
      className="relative overflow-hidden bg-white px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 md:gap-16 lg:grid-cols-5">
          <div className="fade-in-section lg:col-span-2">
            <h2 className="mb-6 text-5xl font-bold tracking-wide text-gray-900 md:mb-8 md:text-7xl">
              <span className="text-red-500">S</span>trengths
            </h2>
            <p className="text-lg text-gray-600">選ばれる理由</p>
          </div>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 lg:col-span-3">
            {strengths.map((strength, index) => (
              <div
                key={index}
                className="fade-in-section rounded-xl border-2 border-gray-200 bg-white p-6 shadow-sm transition-all duration-300"
                style={{ transitionDelay: `${index * 60}ms` }}
              >
                <div className="mb-4 inline-block rounded-full bg-red-50 px-3 py-1 text-sm font-bold text-red-500">
                  {strength.number}
                </div>
                <div>
                  <h3 className="mb-3 text-xl font-semibold text-gray-900">
                    {strength.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-gray-600">
                    {strength.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Strengths;
